import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Degree and Value of Change',
      type: 'table',
      content: {
        '{}': {
          query: {
            '`': {
              selection: {
                '[]': [
                  {
                    '{}': {
                      fields: {
                        '{}': {
                          rank: {
                            '{}': {
                              value: 'High',
                            },
                          },
                          valueOfChange: {
                            '{}': {
                              value: {
                                '#': {
                                  '@': 'valueHigh',
                                },
                              },
                            },
                          },
                          degreeOfChange: {
                            '{}': {
                              value: {
                                '#': {
                                  '@': 'degreeHigh',
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      fields: {
                        '{}': {
                          rank: {
                            '{}': {
                              value: 'Medium',
                            },
                          },
                          valueOfChange: {
                            '{}': {
                              value: {
                                '#': {
                                  '@': 'valueMedium',
                                },
                              },
                            },
                          },
                          degreeOfChange: {
                            '{}': {
                              value: {
                                '#': {
                                  '@': 'degreeMedium',
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      fields: {
                        '{}': {
                          rank: {
                            '{}': {
                              value: 'Low',
                            },
                          },
                          valueOfChange: {
                            '{}': {
                              value: {
                                '#': {
                                  '@': 'valueLow',
                                },
                              },
                            },
                          },
                          degreeOfChange: {
                            '{}': {
                              value: {
                                '#': {
                                  '@': 'degreeLow',
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                ],
              },
              subqueries: {
                valueLow: {
                  filter: {
                    '=': [
                      {
                        '@.': '!value_of_change',
                      },
                      'Low',
                    ],
                  },
                  target: 'ent:!change_impacts:!change_impact',
                  selection: {
                    '@.': '!id',
                  },
                },
                degreeLow: {
                  filter: {
                    '=': [
                      {
                        '@.': '!degree_of_change',
                      },
                      'Low',
                    ],
                  },
                  target: 'ent:!change_impacts:!change_impact',
                  selection: {
                    '@.': '!id',
                  },
                },
                valueHigh: {
                  filter: {
                    '=': [
                      {
                        '@.': '!value_of_change',
                      },
                      'High',
                    ],
                  },
                  target: 'ent:!change_impacts:!change_impact',
                  selection: {
                    '@.': '!id',
                  },
                },
                degreeHigh: {
                  filter: {
                    '=': [
                      {
                        '@.': '!degree_of_change',
                      },
                      'High',
                    ],
                  },
                  target: 'ent:!change_impacts:!change_impact',
                  selection: {
                    '@.': '!id',
                  },
                },
                valueMedium: {
                  filter: {
                    '=': [
                      {
                        '@.': '!value_of_change',
                      },
                      'Medium',
                    ],
                  },
                  target: 'ent:!change_impacts:!change_impact',
                  selection: {
                    '@.': '!id',
                  },
                },
                degreeMedium: {
                  filter: {
                    '=': [
                      {
                        '@.': '!degree_of_change',
                      },
                      'Medium',
                    ],
                  },
                  target: 'ent:!change_impacts:!change_impact',
                  selection: {
                    '@.': '!id',
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'rank',
                  direct: {
                    '{}': {
                      name: 'Rank',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'degreeOfChange',
                  direct: {
                    '{}': {
                      name: 'Degree of Change',
                      type: 'INT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'valueOfChange',
                  direct: {
                    '{}': {
                      name: 'Value of Change',
                      type: 'INT',
                    },
                  },
                },
              },
            ],
          },
        },
      },
    },
  },
}
